// extracted by mini-css-extract-plugin
module.exports = {"numbers":"TextBox_numbers__rliPp","texts":"TextBox_texts__30cbH","details":"TextBox_details__2JlnP"};